import RequestStatus from 'constants/requestStatus'

export const getMessageList = (state) => state?.store?.message.list || []

export const getPagination = (state) => state?.store?.message.pagination || {}

export const systemMessages = (state) => state?.store?.message.systems || []

export const memoizedSystemMessages = (state) =>
  state?.store?.message.systems || {}

export const getFilter = (state) => state.store?.message?.filter || {}

export const isLoading = (state) =>
  state.requests?.message?.getMessages.status === RequestStatus.STARTED
